import * as React from 'react';
import { KeyCodes } from '@fluentui/react/lib/Utilities';

/**
 * Returns a callback suitable for onKeyDown which
 * invokes onCommit when ENTER is pressed and
 * invokes onRevert when ESC is pressed,
 * when the currentValue does not equal the initialValue.
 */
export function useCommitOnEnterRevertOnEscape(
    initialValue: string | undefined,
    currentValue: string | undefined,
    onCommit: (currentValue: string | undefined, e: React.KeyboardEvent) => void,
    onRevert: (initialValue: string | undefined, e: React.KeyboardEvent) => void
): React.KeyboardEventHandler {
    return React.useCallback(
        (e: React.KeyboardEvent) => {
            if (currentValue != initialValue) {
                switch (e.keyCode) {
                    case KeyCodes.enter:
                        e.preventDefault();
                        e.stopPropagation();
                        onCommit(currentValue, e);
                        break;
                    case KeyCodes.escape:
                        // intentionally not stopping propagation so escape can be handled elsewhere
                        onRevert(initialValue, e);
                        break;
                }
            }
        },
        [initialValue, currentValue, onCommit, onRevert]
    );
}
